import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { Project } from "./project";
import { Loader } from "./loader";
import { Export } from "./export";
import styles from "./styles.scss";

function SideBar(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sideBar}>
      {props.isRequestPending ? (
        <Loader />
      ) : (
        <React.Fragment>
          <div className={styles.title}>{t("calendarPage.sideBar.title")}</div>
          <div className={styles.projects}>
            {props.projects.map((project) => (
              <Project
                key={project.uuid}
                project={project}
                isSelected={props.selectedProjects?.includes(project.uuid)}
                onToggle={props.onToggleProject}
              />
            ))}
          </div>
          <ul className={styles.legends}>
            <li>
              <span className={styles.legendHolidays} />
              {t("calendar.holidays")}
            </li>
            <li>
              <span className={styles.legendWeekends} />
              {t("calendar.weekends")}
            </li>
            <li>
              <span className={styles.legendUnavailability} />
              {t("calendar.unavailability")}
            </li>
          </ul>
        </React.Fragment>
      )}
      <Export />
    </div>
  );
}

export { SideBar };
